import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { LookupValueFormatter, FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import clsx from 'clsx'

class StaticBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array,
    valueProp: pt.string,
    textProp: pt.string
  })

  static defaultProps = {
    valueProp: 'Value',
    textProp: 'Text',
    options: []
  }

  render () {
    const { 'data-tid': testId = '', options, valueProp, textProp, groupLabel, groupButton, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) => <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
          <input data-tid={testId} type='text' readOnly invalid={showError} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}
            name={`static${name}`} id={`static${name}`} placeholder={placeHolder} value={LookupValueFormatter(options, value).Text} />
        </FieldLayoutGroup>
        }
      </FieldLayoutBox>
    )
  }
};

export const StaticBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={StaticBoxClass} /> } // eslint-disable-line
export default StaticBox
